/**
 * Clones the given input using JSON.parse/JSON.stringify
 */
export function makeClone<T>(input: MaybeRefOrGetter<T>): T {
  return JSON.parse(JSON.stringify(toValue(input)))
}
